import { useMemo } from 'react'
import { useMember } from '../app/member.jsx'
import { useNow } from '../lib/clock.js'
import { buildModel } from './model.js'

// The Library's view model at the app's clock, or null until the rows are in
export function useLibraryModel() {
  const { lib, me } = useMember()
  const nowMs = useNow()
  return useMemo(
    () => (lib.data && me.status === 'ready' ? buildModel(lib.data, me.person, nowMs) : null),
    [lib.data, me, nowMs],
  )
}
